<template>
  <div class="about">
    <h1>Mobile UI</h1><small>(测试版)</small>
  </div>
</template>
<script>
export default {
    name:'About'
}
</script>
<style scoped>

</style>